import React from "react";
import Tooltip from "../Tooltip";
import { Container, ContainerPetName, PetDetail, PetName } from "./index.style";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IPets } from "../../../interfaces/pets";

const ComponentListModal = (props: IPets) => {
  const petOld = new Date(props.petDOB);
  function monthDiff(d1: Date, d2: Date) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  const petMonth = monthDiff(petOld, new Date());
  const petYear = Math.floor(petMonth / 12);

  return (
    <Container>
      {/* Pet Card */}
      {props.petName && (
        <ContainerPetName>
          <div style={{ display: "flex" }}>
            <PetName>{props.petName} </PetName>
            <Tooltip toolTipText={"คำอธิบาย:   \n" + props.petDisease}>
              <AiOutlineInfoCircle
                size={"1.25rem"}
                style={{ cursor: "pointer", marginLeft: "0.5rem" }}
                color={"#123559"}
              />
            </Tooltip>
          </div>
          <PetDetail>
            <p>{props.petType}</p>
            เพศ <p>{props.petSex}</p>
          </PetDetail>
        </ContainerPetName>
      )}
      {props.petDOB && (
        <PetDetail>
          อายุ{" "}
          <p>
            {petYear} ปี {petMonth % 12} เดือน
          </p>
        </PetDetail>
      )}
      {props.petSpecies && (
        <PetDetail>
          สายพันธ์ <p>{props.petSpecies}</p>
        </PetDetail>
      )}
    </Container>
  );
};
export default ComponentListModal;
